import { render } from "./ModalDeleteAccount.vue?vue&type=template&id=35dea06b"
import script from "./ModalDeleteAccount.vue?vue&type=script&lang=js"
export * from "./ModalDeleteAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__